const textBackColor = (state = {bCol:"transparent"}, action)=>{
    if(action.type === "SET_TEXT_BACK_COLOR"){
        state.bCol = action.color
    }


    return state;
}

export default textBackColor;